export class BuyBonusPopUpEvents {
    public static readonly BUY_BUTTON_CLICKED: symbol = Symbol('BUY_BUTTON_CLICKED');
    public static readonly BUY_POP_UP_CLOSED: symbol = Symbol('BUY_POP_UP_CLOSED');
    public static readonly BET_INC_BUTTON_CLICKED: symbol = Symbol('BET_INC_BUTTON_CLICKED');
    public static readonly BET_DEC_BUTTON_CLICKED: symbol = Symbol('BET_DEC_BUTTON_CLICKED');
    public static readonly FADE_OUT_ANIMATION_FINISHED: symbol = Symbol('FADE_OUT_ANIMATION_FINISHED');
}
